import { useQuery } from '@tanstack/react-query';

import { useAppSelector } from 'store';

import { $apiWithoutClient } from 'modules/global';

import { IOlympicList } from '..';

export const useOlympicView = (id?: string) => {
  const isAuthenticated = useAppSelector(({ authModal }) => authModal.isAuthenticated.status);

  const { data, ...args } = useQuery<{ olympic: IOlympicList }>({
    queryKey: ['olympic-view', id],
    queryFn: async () => {
      const { data } = await $apiWithoutClient.get('/olympic/olympic-view', { params: { id } });

      return { olympic: data?.data };
    },
    refetchOnMount: true,
    enabled: Number.isInteger(Number(id)) || isAuthenticated
  });

  return { ...data, ...args };
};
